import { StoreType } from '@reducers/types';
import { AuthState } from '@reducers/types/auth-state';

export const getAuthState = (state: StoreType): AuthState => state.auth;
